/**
 * Branded Credit Card Info Types
 * Sunbit credit card eligibility and modal display.
 */

export enum BrandedCreditCardInfoTypeId {
  PRE_APPROVED = 1,
  INVITATION_TO_APPLY = 2,
}

export enum BrandedCreditCardInfoTypeLabel {
  PRE_APPROVED = 'Pre-Approved',
  INVITATION_TO_APPLY = 'Invitation To Apply',
}

/**
 * Status codes for the Sunbit branded credit card invitation lifecycle.
 * These codes represent the customer's progression from invitation through card activation.
 */
export enum BrandedCreditCardInfoStatusCode {
  /**
   * Customer has a pending invitation (not yet a card holder).
   * Covers both invitation types:
   * - ITA: Pre-screened but not pre-approved.
   * - Pre-Approved: Pre-screened and pre-approved for a specific credit amount.
   */
  PENDING = 5750,

  /** Card holder approved but has not yet activated by making a first purchase. */
  APPROVED = 5759,

  /** Card holder activated (first purchase made) but has not redeemed the welcome gift. */
  ACTIVATED = 5775,

  /** Former card holder — card has been cancelled. */
  CANCELLED = 5753,

  /** Invitation Expired */
  EXPIRED = 5755,
}

export interface BrandedCreditCardInfo {
  partner: string;
  invitationUrl: string;
  preapprovedAmount: number;
  statuscode: BrandedCreditCardInfoStatusCode;
  invitationTypeLabel: BrandedCreditCardInfoTypeLabel;
  dateExpires: string;
}

/**
 * Eligible invitation types that should trigger the modal display.
 */
export const ELIGIBLE_TYPES: BrandedCreditCardInfoTypeLabel[] = [
  BrandedCreditCardInfoTypeLabel.PRE_APPROVED,
  BrandedCreditCardInfoTypeLabel.INVITATION_TO_APPLY,
];

/**
 * Storage key for persisting the modal shown state across sessions.
 */
export const SUNBIT_BRANDED_CREDIT_CARD_STORAGE_KEY =
  'sunbit-branded-credit-card-modal-shown';
